import {Ref, ref} from "vue";

export class ServiceTransferBlockWarning {
	public static _instance: ServiceTransferBlockWarning | null = null;
	private _triggered: Ref<boolean> = ref(false);

	public static of() {
		if (this._instance === null) this._instance = new ServiceTransferBlockWarning();
		return this._instance;
	}

	public get triggered(): Ref<boolean> {
		return this._triggered;
	}

	public set triggered(value: boolean) {
		this._triggered.value = value;
	}
}
